<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <h6>Dados gravados em {{ pessoa.created_at_f }}</h6>
          <h6 v-show="pessoa.updated_at">Última edição em {{ pessoa.updated_at_f }}</h6>
        </div>
        <div class="col-md-12">
          <label>Unidade</label>
          <input type="text" class="form-control" v-model="pessoa.unidade.nome" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="pessoa.nome" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome social</label>
          <input type="text" class="form-control" v-model="pessoa.nome_social" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome mãe</label>
          <input type="text" class="form-control" v-model="pessoa.nome_mae" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome pai</label>
          <input type="text" class="form-control" v-model="pessoa.nome_pai" disabled />
        </div>
        <div class="col-md-6">
          <label>CNS</label>
          <input type="text" class="form-control" v-model="pessoa.cns" disabled />
        </div>
        <div class="col-md-6">
          <label>CPF</label>
          <input type="text" class="form-control" v-model="pessoa.cpf" disabled />
        </div>
        <div class="col-md-4">
          <label>Sexo</label>
          <input type="text" class="form-control" v-model="pessoa.sexo_f" disabled />
        </div>
        <div class="col-md-4">
          <label>Telefone</label>
          <input type="text" class="form-control" v-model="pessoa.telefone" disabled />
        </div>
        <div class="col-md-4">
          <label>Data de nascimento</label>
          <input type="text" class="form-control" v-model="pessoa.data_nascimento" disabled />
        </div>
        <div class="col-md-3">
          <label>CEP</label>
          <input type="text" class="form-control" v-model="pessoa.cep" disabled />
        </div>
        <div class="col-md-7">
          <label>Logradouro</label>
          <input type="text" class="form-control" v-model="pessoa.logradouro" disabled />
        </div>
        <div class="col-md-2">
          <label>Número</label>
          <input type="text" class="form-control" v-model="pessoa.numero" disabled />
        </div>
        <div class="col-md-3">
          <label>Complemento</label>
          <input type="text" class="form-control" v-model="pessoa.complemento" disabled />
        </div>
        <div class="col-md-3">
          <label>Bairro</label>
          <input type="text" class="form-control" v-model="pessoa.bairro" disabled />
        </div>
        <div class="col-md-3">
          <label>Cidade</label>
          <input type="text" class="form-control" v-model="pessoa.cidade" disabled />
        </div>
        <div class="col-md-3">
          <label>Estado</label>
          <input type="text" class="form-control" v-model="pessoa.estado" disabled />
        </div>
        <div class="col-md-6">
          <label>ID central</label>
          <input type="text" class="form-control" v-model="pessoa.id" disabled />
        </div>
        <div class="col-md-6">
          <label>ID original</label>
          <input type="text" class="form-control" v-model="pessoa.original_id" disabled />
        </div>
        <div class="col-md-6 text-left d-flex align-items-end">
          <h5>Última sincronização realizada em {{ pessoa.sincronizacao_f }}</h5>
        </div>
        <div class="col-md-6 text-right">
          <hr />
          <router-link to="/pessoas" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      pessoa: {},
    };
  },
  computed: {},
  methods: {
    getPessoa: function (id) {
      const self = this;
      const api = self.$store.state.api + "pessoas/" + id + '?with[]=unidade';

      axios
        .get(api)
        .then((response) => {
          if(response.data.data[0])
          {
            self.pessoa = response.data.data[0];
            self.setLoader(50);
          }else{
            this.$router.push("/no-item");
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(50);

    if (id) {
      self.getPessoa(id);
    } else {
      self.setLoader(50);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>